import { routes } from "../../routes";
import { HeaderWithMenu } from "../../shared/components/header-with-menu";

export const BookingsHeader: React.FC = () => {
  return (
    <HeaderWithMenu
      title="Meine Buchungen"
      homePath={routes.home}
      menuItems={[{ name: "Neue Buchung", path: routes.home }]}
    />
  );
};
